import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.856 6.594a.2.2 0 00.288 0L9.117 3.53c.04-.04.104-.04.143 0l.71.732c.04.04.04.107 0 .147L6.287 8.204a.4.4 0 01-.574 0l-.495-.51a.1.1 0 01-.006-.006L2.03 4.409a.106.106 0 010-.147l.71-.731c.04-.041.103-.041.143 0l2.973 3.063z"
  })));
}

export { SvgArrowDown as ReactComponent };
